<template name="examCheckboxSelect">
  <div class="exam-checkbox-select-wrapper">
    <div class="row" v-for="(item, idx) in dataList" :key="idx" :class="{ checked: checkedData.includes(item.id + '') }">
        <div class="col-12">
          <input type="checkbox" name="checkbox-item"
          :value="item.id" :id="`${idScopeName}-${item.id}`"
          :checked="item.checked" @change="handleChange"
          :disabled="isDisabled"
          >
          <label :for="`${idScopeName}-${item.id}`">
            {{ item[propName] }}
          </label>
        </div>
    </div>
  </div>
</template>
<!--
  Basic usage example:
  1. dataList is the array contains checkbox items,
  2. propName is the prop for item name, e.g.'userName', 'lessonName'
  3. idScopeName is a string to prevent duplicated ids on same page
  <examCheckboxSelect :dataList="postList" :propName="propName" :idScopeName="idScopeName"></examCheckboxSelect>
-->

<script type="text/javascript">
export default {
  name: 'examCheckboxSelect',
  props: {
    dataList: Array,
    propName: String,
    isDisabled: Boolean,
    idScopeName: String,
    correctAnswer: Array,
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      checkedData: [], // '0', '1', '2'
    };
  },
  created() {
    this.checkedData = this.correctAnswer.map(idx => idx + ''); // turn number to string type
  },
  methods: {
    handleChange(event) {
      const { checked, value } = event.target;
      if (checked) {
        this.checkedData.push(value);
      } else {
        this.checkedData = this.checkedData.filter(x => x !== value);
      }
      this.$emit('change', this.checkedData);
    },
  },
};
</script>

<style scoped lang="scss">
  .exam-checkbox-select-wrapper {
    display: flex;
    flex-wrap: wrap;
    .row {
      margin: 15px 15px 0 0;
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      // by default .row is display: flex;
      // however contain display:flex child within flexed parent may cause layout issue in IE10/11
      display: block;
      &.checked {
        border: 1px solid #e42029;
        background: url(../assets/images/external/exam-checkbox-checked.png) no-repeat right top;
        background-size: 20px auto;
      }
      .col-12 {
        color: #4a4a4a;
        font-size: 14px;
        padding: 0;
        line-height: 30px;
        input {
          display: none;
        }
        label {
          margin-bottom: 0;
          padding-left: 20px;
          padding-right: 20px;
          cursor: pointer;
        }
      }
    }
  }
</style>
